module.exports = __webpack_public_path__ + "images/b71d49bcf3a304d9093ff8b457ac36c8-Travel Oregon.png";